import React, {useContext, useState} from "react";
import {GlobalStateContext} from "../../../global/context/GlobalStateContext";
import {ZancaSortDeviceOverviewContext} from "../context/ZancaSortDeviceOverviewContext";
import {injectIntl} from "react-intl";
import Modal, {ModalFooter} from "@amzn/meridian/modal";
import Column from "@amzn/meridian/column";
import Text from "@amzn/meridian/text";
import Row from "@amzn/meridian/row";
import Button from "@amzn/meridian/button";
import Toggle from "@amzn/meridian/toggle";
import {getLocalizedMessage} from "../../../util/Localization";
import Loader from "../../../loader/Loader";
import {updateAssetAttribute} from "../network/ZancaSortDeviceNetworkAPI";
import {ASSET_CONFIG_ATTRIBUTES, ZANCASORT_ASSET_TYPE} from "../../../util/Constants";

const ToggleStowStationsModal = (props) => {

    const {open, setOpen, selectedMac} = props;
    const {showWarning, showCustomAlert} = useContext(GlobalStateContext);
    const {viewModel, dispatch} = useContext(ZancaSortDeviceOverviewContext);

    // Visual controls
    const [isUpdating, setIsUpdating] = useState(false);

    // States
    const [topStationEnabled, setTopStationEnabled] = useState(false);
    const [bottomStationEnabled, setBottomStationEnabled] = useState(false);

    const onOpen = () => {
        const device = viewModel.zancaSortDeviceInformation[selectedMac];
        if (device && device.stowStationState) {
            setTopStationEnabled(device.stowStationState.StowStationEnabled_Top);
            setBottomStationEnabled(device.stowStationState.StowStationEnabled_Bottom);
        } else {
            setTopStationEnabled(false);
            setBottomStationEnabled(false);
        }
    };

    const stowStationStateAttributeName = ASSET_CONFIG_ATTRIBUTES[ZANCASORT_ASSET_TYPE].STOW_STATION_STATE;

    const onConfirm = async () => {
        showWarning(
            getLocalizedMessage({intl: props.intl, stringId: "device.editWarning"}),
            async () => {
                setIsUpdating(true);
                
                const success = await updateAssetAttribute(
                    dispatch,
                    selectedMac,
                    stowStationStateAttributeName,
                    {
                        StowStationEnabled_Top: topStationEnabled,
                        StowStationEnabled_Bottom: bottomStationEnabled
                    },
                    showCustomAlert
                );
                if (success) {
                    onClose();
                } else {
                    setIsUpdating(false);
                }
            }
        );
    };

    const onClose = () => {
        setOpen(false);
        setTopStationEnabled(false);
        setBottomStationEnabled(false);
        setIsUpdating(false);
    };

    return (
        <Modal
            title={getLocalizedMessage({intl: props.intl, stringId: "modal.toggleStowStations.title"})}
            open={open}
            onOpen={onOpen}
            onClose={onClose}
            scrollContainer="viewport"
            closeLabel="Close"
            bodySpacingInset="medium"
            width="medium">
            {isUpdating ? (
                <Column spacing="medium" spacingInset="medium" alignmentHorizontal="center">
                    <Loader />
                    <Text type="b200">{getLocalizedMessage({intl: props.intl, stringId: "modal.toggleStowStations.updating"})}</Text>
                </Column>
            ) : (
                <Column spacing="medium" spacingInset="medium">
                    {/* Top Stow Station */}
                    <Row alignmentVertical="center">
                        <div style={{width: "145px", marginRight: "4px", display: "flex", alignItems: "center"}}>
                            <Text tag="label" type="b200" color="primary">
                                {getLocalizedMessage({intl: props.intl, stringId: "modal.toggleStowStations.topStation"})}:
                            </Text>
                        </div>
                        <div style={{display: "flex", alignItems: "center", marginTop: "4px"}}>
                            <Toggle 
                                checked={topStationEnabled}
                                onChange={setTopStationEnabled}
                            />
                        </div>
                    </Row>
                    
                    {/* Bottom Stow Station */}
                    <Row alignmentVertical="center">
                        <div style={{width: "145px", marginRight: "4px", display: "flex", alignItems: "center"}}>
                            <Text tag="label" type="b200" color="primary">
                                {getLocalizedMessage({intl: props.intl, stringId: "modal.toggleStowStations.bottomStation"})}:
                            </Text>
                        </div>
                        <div style={{display: "flex", alignItems: "center", marginTop: "4px"}}>
                            <Toggle 
                                checked={bottomStationEnabled}
                                onChange={setBottomStationEnabled}
                            />
                        </div>
                    </Row>
                </Column>
            )}
            <ModalFooter>
                <Row alignmentHorizontal="right" widths="fit">
                    <Button 
                        type="secondary" 
                        size="medium" 
                        onClick={onClose}
                        disabled={isUpdating}
                    >
                        {getLocalizedMessage({intl: props.intl, stringId: "modal.cancel"})}
                    </Button>
                    <Button 
                        type="primary" 
                        size="medium" 
                        onClick={onConfirm}
                        disabled={isUpdating}
                    >
                        {getLocalizedMessage({intl: props.intl, stringId: "modal.confirm"})}
                    </Button>
                </Row>
            </ModalFooter>
        </Modal>
    );
};

export default injectIntl(ToggleStowStationsModal);



// WEBPACK FOOTER //
// ./src/components/devicemanagement/zancasort/modal/ToggleStowStationsModal.js